import React, { Dispatch, SetStateAction, useState } from "react"
import tw from "twin.macro"
import { AuthenticatonPage } from ".."
import { CreateAccount } from "./createAccount"
import { VerifyEmail } from "../../verification/verifyEmail"
import { MagicSignUp } from "./magicSignUp"
import { Button } from "../../formElements/button"
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg"
import { useTranslation } from "next-i18next"
import { VerifyPhone } from "../../verification/verifyPhone"
import { never } from "../../../utils"

interface JoinProp {
  setPage: Dispatch<SetStateAction<AuthenticatonPage>>
  setShow?: Dispatch<SetStateAction<boolean>>
  setNotDismissable?: Dispatch<SetStateAction<boolean>>
  redirectUserAfterCreation?: boolean
}
export enum JoinStep {
  MagicSignUp = "MagicSignUp",
  VerifyEmail = "VerifyEmail",
  VerifyPhone = "VerifyPhone",
  CreateAccount = "CreateAccount",
}
export const Join = ({ setPage, setShow, setNotDismissable, redirectUserAfterCreation }: JoinProp) => {
  const { t } = useTranslation("authentication")
  const [joinStep, setJoinStep] = useState(JoinStep.MagicSignUp)
  const [signUpEmail, setSignUpEmail] = useState("")
  const [signUpPhoneNumber, setSignUpPhoneNumber] = useState("")
  const [signUpPhoneCountryCode, setSignUpPhoneCountryCode] = useState(0)

  const renderVerifyEmail = (
    <>
      <VerifyEmail {...{ email: signUpEmail, setJoinStep }} />
      <div tw="flex flex-1 justify-start items-end">
        <Button
          dataTestId="edit"
          action={t("join.edit_email")}
          icon={<ArrowRight tw="rotate-180" />}
          iconBefore={true}
          onClick={() => setJoinStep(JoinStep.MagicSignUp)}
        />
      </div>
    </>
  )
  const renderVerifyPhone = (
    <>
      <VerifyPhone {...{ phoneNumber: signUpPhoneNumber, phoneCountryCode: signUpPhoneCountryCode, setJoinStep }} />
      <div tw="flex flex-1 justify-start items-end">
        <Button
          dataTestId="edit"
          action={t("join.edit_phone")}
          icon={<ArrowRight tw="rotate-180" />}
          iconBefore={true}
          onClick={() => setJoinStep(JoinStep.MagicSignUp)}
        />
      </div>
    </>
  )

  const renderView = () => {
    switch (joinStep) {
      case JoinStep.MagicSignUp:
        return (
          <MagicSignUp {...{ setPage, setJoinStep, setSignUpEmail, setSignUpPhoneNumber, setSignUpPhoneCountryCode }} />
        )
      case JoinStep.VerifyEmail: {
        return <>{renderVerifyEmail}</>
      }
      case JoinStep.VerifyPhone: {
        return <>{renderVerifyPhone}</>
      }
      case JoinStep.CreateAccount: {
        return (
          <CreateAccount
            {...{
              email: signUpEmail,
              phoneNumber: signUpPhoneNumber,
              phoneCountryCode: signUpPhoneCountryCode,
              setShow,
              setNotDismissable,
              redirectUserAfterCreation,
            }}
          />
        )
      }
      default:
        return never(joinStep)
    }
  }
  return <>{renderView()}</>
}
